export default options => {
  const { subject } = nx.hashlize();

  // options.url = nx.tmpl(options.url, { subject });

  return options;
};
